import React from "react";
import ScreenPulled from "./ScreenPulled";
import ScreenSaved from "./ScreenSaved";

const SCREENS = { pulled: ScreenPulled, saved: ScreenSaved };

export default function AppPanel({ app, active, offstage }) {
  const Screen = SCREENS[app.id];

  return (
    <article
      className={`panel panel--app panel--${app.id}`}
      data-on={active || undefined}
      inert={offstage || undefined}
    >
      <div className="panel__grid">
        <div className="panel__text">
          <div className="panel__meta">
            <span className="mono">{app.index}</span>
            <span className="panel__status mono">
              <i />
              {app.status}
            </span>
          </div>

          <h3 className="panel__name display">{app.name}</h3>
          <p className="panel__cat mono">{app.category}</p>
          <p className="panel__tagline serif">{app.tagline}</p>
          <p className="panel__lede">{app.lede}</p>

          <ul className="panel__features">
            {app.features.map(([title, body], i) => (
              <li key={title} style={{ "--i": i }}>
                <b>{title}</b>
                <span>{body}</span>
              </li>
            ))}
          </ul>

          <blockquote className="panel__quote serif">
            <span>“</span>
            {app.quote}
          </blockquote>

          <div className="panel__actions">
            <a
              className="btn btn--fill"
              href={app.links.site}
              target="_blank"
              rel="noreferrer"
              data-lens="OPEN"
            >
              <span>Visit {app.name.toLowerCase()}</span>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 17 17 7M9 7h8v8" />
              </svg>
            </a>

            {app.links.store && (
              <a
                className="btn"
                href={app.links.store}
                target="_blank"
                rel="noreferrer"
                data-lens="INSTALL"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true" className="btn__apple">
                  <path d="M16.4 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.8-3.5.8s-1.8-.8-3-.8c-1.5 0-2.9.9-3.7 2.3-1.6 2.7-.4 6.8 1.1 9 .8 1.1 1.6 2.3 2.8 2.3 1.1 0 1.6-.7 2.9-.7s1.7.7 2.9.7 2-1.1 2.7-2.2c.9-1.2 1.2-2.5 1.3-2.5-.1 0-2.4-.9-2.4-3.6ZM14.2 5.6c.6-.8 1-1.8.9-2.9-.9 0-2 .6-2.6 1.4-.6.7-1.1 1.7-.9 2.8 1 0 2-.5 2.6-1.3Z" />
                </svg>
                <span>App Store</span>
              </a>
            )}
          </div>

          <ul className="panel__proof">
            {app.proof.map((p) => (
              <li className="mono" key={p}>
                {p}
              </li>
            ))}
          </ul>
        </div>

        <div className="panel__device">
          <span className="panel__halo" aria-hidden="true" />
          <span className="panel__wordmark display" aria-hidden="true">
            {app.name}
          </span>
          <Screen active={active} />
        </div>
      </div>
    </article>
  );
}
